import { __rest, __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import { Text } from '@chakra-ui/react';
import React from 'react';

var Typography = function (props) {
    var variant = props.variant, children = props.children, extraProps = __rest(props, ["variant", "children"]);
    var fontSize = "14px";
    var lineHeight = "20px";
    var fontWeight = "normal";
    var fontFamily = "Work Sans";
    switch (variant) {
        case "h1":
            fontSize = "32px";
            lineHeight = "40px";
            fontWeight = "600";
            break;
        case "h1-r-bold":
            fontFamily = "Roboto";
            fontSize = "32px";
            lineHeight = "40px";
            fontWeight = "700";
            break;
        case "h1-r-medium":
            fontFamily = "Roboto";
            fontSize = "32px";
            lineHeight = "40px";
            fontWeight = "500";
            break;
        case "h2-r-bold":
            fontFamily = "Roboto";
            fontSize = "24px";
            lineHeight = "32px";
            fontWeight = "700";
            break;
        case "h2-r-medium":
            fontFamily = "Roboto";
            fontSize = "24px";
            lineHeight = "32px";
            fontWeight = "500";
            break;
        case "h3-r-bold":
            fontFamily = "Roboto";
            fontSize = "20px";
            lineHeight = "24px";
            fontWeight = "700";
            break;
        case "h3-r-medium":
            fontFamily = "Roboto";
            fontSize = "20px";
            lineHeight = "24px";
            fontWeight = "500";
            break;
        case "h1-i-bold":
            fontFamily = "Inter";
            fontSize = "32px";
            lineHeight = "40px";
            fontWeight = "700";
            break;
        case "h1-i-medium":
            fontFamily = "Inter";
            fontSize = "32px";
            lineHeight = "40px";
            fontWeight = "500";
            break;
        case "h2-i-bold":
            fontFamily = "Inter";
            fontSize = "24px";
            lineHeight = "32px";
            fontWeight = "700";
            break;
        case "h2-i-medium":
            fontFamily = "Inter";
            fontSize = "24px";
            lineHeight = "32px";
            fontWeight = "500";
            break;
        case "h3-i-bold":
            fontFamily = "Inter";
            fontSize = "20px";
            lineHeight = "24px";
            fontWeight = "700";
            break;
        case "h3-i-medium":
            fontFamily = "Inter";
            fontSize = "20px";
            lineHeight = "24px";
            fontWeight = "500";
            break;
        case "h1-w-semibold":
            fontSize = "32px";
            lineHeight = "40px";
            fontWeight = "600";
            break;
        case "h1-w-medium":
            fontSize = "32px";
            lineHeight = "40px";
            fontWeight = "500";
            break;
        case "h2-w-semibold":
            fontSize = "24px";
            lineHeight = "32px";
            fontWeight = "600";
            break;
        case "h2-w-medium":
            fontSize = "24px";
            lineHeight = "32px";
            fontWeight = "500";
            break;
        case "h3-w-semibold":
            fontSize = "20px";
            lineHeight = "24px";
            fontWeight = "600";
            break;
        case "h3-w-medium":
            fontSize = "20px";
            lineHeight = "24px";
            fontWeight = "500";
            break;
        case "h2":
            fontSize = "24px";
            lineHeight = "32px";
            fontWeight = "600";
            break;
        case "h3":
            fontSize = "20px";
            lineHeight = "24px";
            fontWeight = "600";
            break;
        case "subheading1":
            fontSize = "18px";
            lineHeight = "24px";
            fontWeight = "500";
            break;
        case "subheading1-r":
            fontSize = "18px";
            lineHeight = "24px";
            fontWeight = "500";
            fontFamily = "Roboto";
            break;
        case "subheading2":
            fontSize = "16px";
            lineHeight = "24px";
            break;
        case "subheading2-r":
            fontFamily = "Roboto";
            fontSize = "16px";
            lineHeight = "24px";
            break;
        case "subheading2-i":
            fontFamily = "Inter";
            fontSize = "16px";
            lineHeight = "24px";
            break;
        case "body-i":
            fontFamily = "Inter";
            fontSize = "14px";
            lineHeight = "20px";
            fontWeight = "500";
            break;
        case "small":
            fontSize = "14px";
            lineHeight = "16px";
            break;
        case "small-r":
            fontFamily = "Roboto";
            fontSize = "14px";
            lineHeight = "16px";
            break;
        case "small-i":
            fontFamily = "Inter";
            fontSize = "14px";
            lineHeight = "16px";
            break;
        case "xsmall":
            fontSize = "12px";
            lineHeight = "16px";
            break;
        case "xsmall-r":
            fontFamily = "Roboto";
            fontSize = "12px";
            lineHeight = "16px";
            break;
        case "xsmall-i":
            fontFamily = "Inter";
            fontSize = "12px";
            lineHeight = "16px";
            fontWeight = "500";
            break;
        case "tiny":
            fontSize = "10px";
            lineHeight = "12px";
            break;
        case "tiny-r":
            fontFamily = "Roboto";
            fontSize = "10px";
            lineHeight = "12px";
            break;
        case "tiny-i":
            fontFamily = "Inter";
            fontSize = "10px";
            lineHeight = "12px";
            break;
    }
    return (React.createElement(Text, __assign({ fontSize: fontSize, lineHeight: lineHeight, fontWeight: fontWeight, fontFamily: fontFamily }, extraProps), children));
};

export { Typography as default };
//# sourceMappingURL=Typography.js.map
